import Vue from 'vue'
import { VSnackbar } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib/components'

export const VSnackbarDefault = Vue.component('VSnackbarDefault', {
	name: 'VSnackbarDefault',

    props: {
		show: { type: Boolean, default: false },
        text: {type: String, required: true},
        snackType: {type: String, default: 'success'}
	},

    render() {
        return (
            <VSnackbar vModel={this.show} color="#F5F5F7">
                {this.getIcon()}
                <span style="color: #000">{this.text}</span>
            </VSnackbar>
        )
    },

    methods: {
        getIcon() {
            let iconName = 'mdi-check-circle-outline'
            let iconColor = '#009850'

            switch (this.snackType) {
                case 'error':
                    iconName = 'mdi-close-circle-outline'
                    iconColor = '#c62828'
                    break

                case 'success':
                    iconName = 'mdi-check-circle-outline'
                    iconColor = '#009850'
                    break
            }

            return ( 
                <VIcon class="mr-2" size="18" color={iconColor}>{iconName}</VIcon>
            )
        }
    },
})

export default VSnackbarDefault